<div class="content-block">

    <!-- Content Header (Page header) -->


    <!-- <div class="row">
           <div class="col-sm-6">
             <h1 class="m-0 text-dark">Dipendenti</h1>
           </div>
           <div class="col-sm-6">
             <ol class="breadcrumb float-sm-right">
               <li class="breadcrumb-item"><a href="/home">Dashboard</a></li>
               <li class="breadcrumb-item">Dipendenti</li>
             </ol>
           </div>
          </div>-->
    <div class="row">
        <div class="col-12">
            <div class="d-flex justify-content-between align-items-center mb-3">
                <h2 class="content-block">Dipendenti</h2>
                <div class="d-flex gap-4">
                    <app-btn-new-dipendente></app-btn-new-dipendente>

                    <!-- <dx-button icon="xlsfile" stylingMode="contained" type="default" text="Importa dati dipendenti"
                        (onClick)="onXlsButtonClick()">
                    </dx-button> -->
                </div>
            </div>
        </div>
    </div>



    <div class="card primary">
        <!-- <div class="card-header">
           <h3 class="card-title">
             <i class="fa fa-chart-pie mr-1"></i>
             Elenco dei dipendenti
             
           </h3>
           <div style="float:right;">
              <dx-button                
                icon="xlsfile"
                stylingMode="contained"
                type="default"
                text="Importa dati dipendenti"
                (onClick)="onXlsButtonClick($event)"
                >
              </dx-button>
          </div>
           
         </div>-->
        <div class="card-body">

            <dx-data-grid #grid [dataSource]="dataSource" keyExpr="id" [showBorders]="true" [focusedRowEnabled]="true"
                [focusedRowIndex]="0" [allowColumnResizing]="true" [columnAutoWidth]="true"
                [columnResizingMode]="columnResizingMode" [showColumnLines]="true" [showRowLines]="true"
                [rowAlternationEnabled]="true" (onRowDblClick)="goToDashboard($event.data)"
                (onExporting)="onExporting($event)"
                (onContentReady)="onContentReady($event)">

                <dxo-export [enabled]="true"></dxo-export>
                <dxo-editing mode="row" [allowAdding]="false" [allowUpdating]="false" [allowDeleting]="false"
                    [selectTextOnEditStart]="true" [useIcons]="true">
                    <dxo-texts confirmDeleteMessage="Confermare la cancellazione?"></dxo-texts>
                </dxo-editing>

                <!--                <dxi-column type="buttons" [width]="110">
                        <dxi-button name="edit" ></dxi-button>
                        <dxi-button name="delete"></dxi-button>
                    </dxi-column> -->

                <dxo-paging [pageSize]="10"></dxo-paging>
                <dxo-pager [showPageSizeSelector]="true" [showInfo]="true"></dxo-pager>
                <dxo-filter-row [visible]="true"></dxo-filter-row>
                <dxo-selection mode="single"></dxo-selection>

                <dxo-data-grid-selection mode="multiple" showCheckBoxesMode="always"></dxo-data-grid-selection>

                <dxo-data-grid-toolbar>
                    
                    <dxi-data-grid-item location="before" class="solo-attivi">
                        Solo Dipendenti Attivi<dx-check-box [(value)]="soloAttivi" (onValueChanged)="onAttiviChanged($event)"></dx-check-box>
                    </dxi-data-grid-item>
                    <dxi-data-grid-item name="exportButton" location="after"></dxi-data-grid-item>

                    <dxi-data-grid-item location="after">
                        <dx-button (onClick)="stampaEtichetteDipendenti()" icon="print" text="Stampa Etichette"
                            stylingMode="text">
                        </dx-button>
                    </dxi-data-grid-item>
                </dxo-data-grid-toolbar>
                <dxi-column name="detail§Anagra" [allowFiltering]="false" [allowSorting]="false"
                    cellTemplate="detailAnagra" width="35" caption="">
                </dxi-column>
                <dxi-column dataField="id" [formItem]="{ visible: false }" [visible]="false" [allowEditing]="false"
                    width="35">
                </dxi-column>
                <dxi-column dataField="attivo" width="60">

                </dxi-column>
                <dxi-column dataField="codice" [formItem]="{ visible: true }" [visible]="true" [allowEditing]="false"
                    width="100">
                </dxi-column>
                <dxi-column dataField="nominativo" width="300" [sortIndex]="1" sortOrder="asc">
                </dxi-column>

                <dxi-column dataField="codFiscale">
                </dxi-column>

                <dxi-column dataField="idReparto" caption="Reparto">
                    <dxo-lookup [dataSource]="listReparti" valueExpr="id"
                        [displayExpr]="getRepartoDisplayExpr"></dxo-lookup>
                </dxi-column>

                <dxi-column dataField="idResponsabile" caption="Responsabile">
                    <dxo-lookup [dataSource]="listDipendenti" valueExpr="id"
                        [displayExpr]="getResponsabileDisplayExpr"></dxo-lookup>
                </dxi-column>

                <dxi-column dataField="idMansione" caption="Mansione">
                    <dxo-lookup [dataSource]="listMansioni" valueExpr="id"
                        [displayExpr]="getMansioneDisplayExpr"></dxo-lookup>
                </dxi-column>


                <div *dxTemplate="let d of 'detailAnagra'">
                    <i class="dx-icon-edit" (click)="dettaglioDipendente(d.data.id)" style="cursor: pointer;"
                        data-toggle="tooltip" data-placement="top" title="Dettaglio dipendente"></i>
                </div>

                <dxo-paging [pageSize]="20">
                </dxo-paging>
                <dxo-pager visible="true" allowedPageSizes="true" displayMode="full" showPageSizeSelector="true"
                    showInfo="true" showNavigationButtons="true">
                </dxo-pager>


            </dx-data-grid>


        </div><!-- /.card-body -->
    </div>
    <!-- /.card -->
</div>


<dx-load-panel #loadPanel shadingColor="rgba(0,0,0,0.4)" [(visible)]="visibleLoadPanel" [showIndicator]="true"
    [showPane]="true" [shading]="true" [hideOnOutsideClick]="false">
</dx-load-panel>

@if(popupInfoBarCode){
<dx-popup [width]="600" [height]="250" [showTitle]="true" title="Informazioni Aggiuntive" [dragEnabled]="false"
    [hideOnOutsideClick]="true" [(visible)]="popupInfoBarCode">
    <app-popup-barcode (popupBarcodeEventEmitter)="onPopupBarcodeEventEmitter($event)"></app-popup-barcode>
</dx-popup>
}